export default __webpack_public_path__ + "static/media/content_tab03_1_02.4b135938.jpg";